module.exports = __webpack_public_path__ + "img/empty-waiter.99713c4.svg";